import { render, staticRenderFns } from "./ExamPackageDo.vue?vue&type=template&id=b2378720&scoped=true&"
import script from "./ExamPackageDo.vue?vue&type=script&lang=js&"
export * from "./ExamPackageDo.vue?vue&type=script&lang=js&"
import style0 from "./ExamPackageDo.vue?vue&type=style&index=0&id=b2378720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2378720",
  null
  
)

export default component.exports